/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const updateSubscriptionRequestSchema = z.object({
  status: z.string().optional(),
  planKey: z.string().optional(),
  expiresDate: z.number().nullable().optional(),
  autoRenewing: z.number().optional(),
});

export type IUpdateSubscriptionRequest = z.infer<typeof updateSubscriptionRequestSchema>;
